// extracted by css-extract-rspack-plugin
export default {"CopyButton":"CopyButton-module__CopyButton___NbN6h"};